import React from "react";
import AboutUs from "../Components/AboutPageComponents/AboutUs";
import MissionAndGoal from "../Components/AboutPageComponents/MissionAndGoal";

function About() {
  return (
    <>
      <AboutUs />
      <MissionAndGoal />
    </>
  );
}

export default About;
